import * as React from 'react';

interface IIconProps {
  type?: string;
  children: any;
}

const Nav = (props: IIconProps) => {
  return (
    <div className={`nav${props.type ? ` nav--${props.type}` : ``}`}>
      {props.children}
    </div>
  );
};

export default Nav;


// WEBPACK FOOTER //
// ./src/modules/Nav/Nav.tsx